import { handleUnauthRoute, handleAuthRoute, personaRouterMiddleware } from './authGuard';
const MainLayout = () => import(/* webpackChunkName: "main layout" */ '@/layout/MainLayout.vue');
const LandingPage = () => import(/* webpackChunkName: "landing page" */ '@/views/LandingPage.vue');
const UserManagement = () => import(/* webpackChunkName: "user management page" */ '@/views/user-management/UserManagement.vue');
const AdminPanel = () => import(/* webpackChunkName: "admin panel" */ '@/views/admin-panel/AdminPanel.vue');
const UserSettings = () => import(/* webpackChunkName: "user settings" */ '@/views/user-settings/UserSettings.vue');
const RequestList = () => import(/* webpackChunkName: "request List" */ '@/views/requests/RequestList.vue');
const NewRequest = () => import(/* webpackChunkName: "user management page" */ '@/views/requests/create/NewRequest.vue');
const UpdateRequest = () => import(/* webpackChunkName: "user management page" */ '@/views/requests/create/UpdateRequest.vue');
const RequestStatus = () => import(/* webpackChunkName: "request status" */ '@/views/requests/RequestStatus.vue');
const PaymentDocument = () => import(/* webpackChunkName: "payment document" */ '@/views/payment-document/PaymentDocumentList.vue');
const Reports = () => import(/* webpackChunkName: "reports" */ '@/views/reports/Reports.vue');
const UnauthorizedRoute = () => import(/* webpackChunkName: "unauthorized" */ '@/views/UnauthorizedRoute.vue');
const AuditLog = () => import(/* webpackChunkName: "r-m" */ '@/views/audit/Audit.vue');
const PaymentDocumentStatus = () => import(/* webpackChunkName: "Payment Document Status" */ '@/views/payment-document/PaymentDocumentStatus.vue');
const CreatePaymentDocument = () => import(/* webpackChunkName: "CreatePaymentDocument" */ '@/views/payment-document/create/CreatePaymentDocument.vue');
const UpdatePaymentDocument = () => import(/* webpackChunkName: "UpdatePaymentDocument" */ '@/views/payment-document/create/UpdatePaymentDocument.vue');
const BulkRequest1 = () => import(/* webpackChunkName: "Bulk Request 1" */ '@/views/bulk-request-1/bulk-request-1.vue');
const BulkRequest2 = () => import(/* webpackChunkName: "Bulk Request 2" */ '@/views/bulk-request-2/bulk-request-2.vue');
const ActionCenter = () => import(/* webpackChunkName: "Action Center" */ '@/views/action-center/ActionCenter.vue');
const ActionItemDetail = () => import(/* webpackChunkName: "Action Center" */ '@/views/action-center/ActionItemDetail.vue');

import Login from '@/views/Login';

export default [
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: handleUnauthRoute,
    },
    {
        path: '/',
        component: MainLayout,
        beforeEnter: handleAuthRoute,
        name: 'base',
        children: [
            {
                path: '/',
                redirect: '/home',
            },
            {
                path: '/home',
                component: LandingPage,
                beforeEnter: personaRouterMiddleware,
                name: 'home-page',
            },
            {
                path: '/user-management',
                component: UserManagement,
                name: 'user-management',
            },
            {
                path: '/admin-panel',
                component: AdminPanel,
                name: 'admin-panel',
            },
            {
                path: '/user-settings',
                component: UserSettings,
                name: 'user-settings',
            },
            {
                path: '/requests',
                component: RequestList,
                name: 'request-list',
            },
            {
                path: '/bulk-request-1',
                component: BulkRequest1,
                name: 'bulk-request-1',
            },
            {
                path: '/bulk-request-2',
                component: BulkRequest2,
                name: 'bulk-request-2',
            },
            {
                path: '/new-request',
                component: NewRequest,
                name: 'create-new-request',
            },
            {
                path: '/create-request/:id',
                component: UpdateRequest,
                name: 'update-request',
            },
            {
                path: '/request/status/:id',
                component: RequestStatus,
                name: 'request-status',
            },
            {
                path: '/payment-document',
                component: PaymentDocument,
                name: 'payment-document-list',
            },
            {
                path: '/payment-document/status/:id',
                component: PaymentDocumentStatus,
                name: 'payment-document-status',
            },
            {
                path: '/payment-document/create',
                component: CreatePaymentDocument,
                name: 'create-payment-document',
            },
            {
                path: '/payment-document/update/:id',
                component: UpdatePaymentDocument,
                name: 'update-payment-document',
            },
            {
                path: '/reports',
                component: Reports,
                name: 'reports',
            },
            {
                path: '/audit-logs',
                component: AuditLog,
                name: 'audit-logs',
            },
            {
                path: '/action-center',
                component: ActionCenter,
                name: 'action-center',
            },
            {
                path: '/action-center/request/:requestId/task/:taskId/type/:type/group/:isGroup',
                component: ActionItemDetail,
                name: 'action-item-detail',
            },
        ],
    },
    {
        path: '/unauthorized',
        component: UnauthorizedRoute,
        name: 'unauthorized',
        beforeEnter: handleAuthRoute,
    },
];
